function complement(num) {
    return num < 10 ? `0${num}` : num; 
}
export default (date, format = 'yyyy-MM-dd HH:mm') => {
    if (!date) {
        return ""
    }
    if (typeof date === 'string') {
        date = new Date(date);
    }
    const year = date.getFullYear();
    const month = complement(date.getMonth() + 1);
    const day = complement(date.getDate());
    const hour = complement(date.getHours());
    const minute = complement(date.getMinutes());
    const second = complement(date.getSeconds());
    if (format === 'yyyy-MM-dd HH:mm:ss') {
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`; 
    }
    if (format === 'yyyy-MM-dd HH:mm') {
        return `${year}-${month}-${day} ${hour}:${minute}`; 
    }
    if (format === 'yyyy-MM-ddTHH:mm') {
        return `${year}-${month}-${day}T${hour}:${minute}`; 
    }
    if (format === 'yyyy-MM-dd') {
        return `${year}-${month}-${day}`; 
    }
    if (format === 'yyyy-MM') {
        return `${year}-${month}`; 
    }
    return ""   
}


// WEBPACK FOOTER //
// ./src/util/dateFormat.js